<template>
  <div>
    <div class="q-px-md">
      <div style="display: flex; vertical-align: middle;">
        <div class="q-gutter-md" style="margin-left: auto;">
          <q-btn
            flat
            no-caps
            label="Add"
            @click.stop="addGroupFunction(null, 'label')"
            :disabled="searchScopes.length == 10"
            class="action-button"
            style="
              display: inline-block;
              vertical-align: middle;
              color: #0067c1;
            "
          />
          <q-btn
            flat
            no-caps
            label="Remove"
            @click="deleteGroupFunction"
            :disabled="searchScopes.length == 1"
            class="action-button"
            style="
              display: inline-block;
              vertical-align: middle;
              color: #0067c1;
            "
          />
        </div>
      </div>
    </div>

    <div
      v-for="(queryRow, index) in searchScopes"
      :key="index"
      style="display: block; justify-content: center; margin: 16px; padding-bottom: 10px"
    >
      <div>
        <q-select
          outlined
          label="Metadata"
          v-model="queryRow.searchAttribute"
          :options="metadataOptions"
          class="inputMetadataType"
          style="width: 100%"
        >
          <template v-slot:after>
            <AdvancedSearchInput
              @setSearchText = "setSearchText"
              :label="getSearchAttribute(queryRow.searchAttribute.value).label"
              :selection="queryRow.searchAttribute.value"
              :searchTextValue="queryRow.searchText"
              :index="index"
            />
          </template>
        </q-select>
      </div>
    </div>

    <div>
      <div
        style="
          display: flex;
          justify-content: right;
          margin: 20px;
        "
      >
        <q-btn
          unelevated
          no-caps
          label="Cancel"
          text-color="white"
          style="background: #8c8c8c"
          @click="CommonHelper.cancelSearch()"
          v-if="CommonHelper.displayCancelBtn.value"
        />
        <q-btn
          unelevated
          no-caps
          icon="search"
          label="Search"
          text-color="white"
          style="background: #0067c1; margin-left: 16px;"
          @click="submitAdvancedSearch"
          :disabled="CommonHelper.loadingInitialSearchResults.value"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import AdvancedSearchInput from "./AdvancedSearchInput";
import LocSchoolMap from "../../assets/CPT-Map-LOC-School.json";
import CommonHelper from "../helper/CommonHelper.js";

export default {
  name: "AdvancedSearchContainer",
  props: {
    scopeFields: Array
  },
  components: {
    AdvancedSearchInput
  },
  setup(props, { emit }) {
    const metadataOptions = computed(() => {
      var metadataOptionsArray = [];

      addMetadataOption("action_category", metadataOptionsArray);
      addMetadataOption("company_name", metadataOptionsArray);
      addMetadataOption("delivery_party", metadataOptionsArray);
      addMetadataOption("description", metadataOptionsArray);
      addMetadataOption("document_category", metadataOptionsArray);
      addMetadataOption("label", metadataOptionsArray);
      addMetadataOption("invoice_number", metadataOptionsArray);
      addMetadataOption("island", metadataOptionsArray);
      addMetadataOption("job_number", metadataOptionsArray);
      addMetadataOption("project_number", metadataOptionsArray);
      addMetadataOption("purchase_order_number", metadataOptionsArray);
      addMetadataOption("purchase_order_originator", metadataOptionsArray);
      addMetadataOption("report_date", metadataOptionsArray);
      addMetadataOption("location_id", metadataOptionsArray);
      addMetadataOption("service_contract_type", metadataOptionsArray);
      addMetadataOption("file_type", metadataOptionsArray);
      addMetadataOption("vendor_or_supplier", metadataOptionsArray);
      addMetadataOption("work_order_number", metadataOptionsArray);
      addMetadataOption("file_year", metadataOptionsArray);

      return metadataOptionsArray;
    });

    /*
     * Conditionally adds a value to the metadataOptions array
     */
    function addMetadataOption(metadataOption, metadataOptionsArray) {
      if (props.scopeFields.includes(metadataOption)) {
        if (metadataOption === "report_date") {
          metadataOptionsArray.push(getSearchAttribute("report_date_begin"));
          metadataOptionsArray.push(getSearchAttribute("report_date_end"));
        } else {
          metadataOptionsArray.push(getSearchAttribute(metadataOption));
        }
      }
    }

    /*
     * Returns the "searchAttribute" value that corresponds to the given metadataOption
     */
    function getSearchAttribute(metadataOption) {
      var metadataOptionLabel = "";

      switch (metadataOption) {
        case "action_category":
          metadataOptionLabel = "Category";
          break;
        case "company_name":
          metadataOptionLabel = "Company Name";
          break;
        case "delivery_party":
          metadataOptionLabel = "Delivery Party";
          break;
        case "description":
          metadataOptionLabel = "Description";
          break;
        case "document_category":
          metadataOptionLabel = "Doc. Category";
          break;
        case "file_type":
          metadataOptionLabel = "Type";
          break;
        case "file_year":
          metadataOptionLabel = "Year";
          break;
        case "invoice_number":
          metadataOptionLabel = "Inv. Num.";
          break;
        case "island":
          metadataOptionLabel = "Island";
          break;
        case "job_number":
          metadataOptionLabel = "Job Num.";
          break;
        case "label":
          metadataOptionLabel = "Doc. Name";
          break;
        case "location_id":
          metadataOptionLabel = "School";
          break;
        case "project_number":
          metadataOptionLabel = "Proj. Num.";
          break;
        case "purchase_order_number":
          metadataOptionLabel = "P.O. Num.";
          break;
        case "purchase_order_originator":
          metadataOptionLabel = "P.O. Originator";
          break;
        case "report_date_begin":
          metadataOptionLabel = "Rep. Dt. Begin";
          break;
        case "report_date_end":
          metadataOptionLabel = "Rep. Dt. End";
          break;
        case "service_contract_type":
          metadataOptionLabel = "Serv. Cont. Type";
          break;
        case "vendor_or_supplier":
          metadataOptionLabel = "Vendor/Supplier";
          break;
        case "work_order_number":
          metadataOptionLabel = "W.O. Num.";
          break;
      }

      var searchAttribute = { value: metadataOption, label: metadataOptionLabel };

      return searchAttribute;
    }

    const searchScopes = ref([
      {
        searchText: null,
        searchAttribute: getSearchAttribute("label"),
      },
    ]);

    function addGroupFunction(searchTextValue, searchAttributeValue) {
      searchScopes.value.push(
        {
          searchText: searchTextValue,
          searchAttribute: getSearchAttribute(searchAttributeValue),
        },
      );
    }

    function deleteGroupFunction() {
      searchScopes.value.splice(-1);
    }

    function setSearchText(index, searchTextValue) {
      searchScopes.value[index].searchText = searchTextValue;
    }

    function submitAdvancedSearch() {
      if (!CommonHelper.loadingInitialSearchResults.value) {
        // filter out empty searchScopes, but add back the default searchScope if all searchScopes are filtered out
        searchScopes.value = searchScopes.value.filter((searchScope) => {
          return searchScope.searchText !== null && searchScope.searchText !== "";
        });

        if (searchScopes.value.length === 0) {
          addGroupFunction(null, 'label');
        }

        const queryArray = JSON.parse(JSON.stringify(searchScopes.value));

        CommonHelper.submitSearch(queryArray);
      }
    }

    const runQueryAdvancedSearch = computed(() => {
      return CommonHelper.firestoreTableInput.value === null && CommonHelper.indexCounts.value !== null && CommonHelper.loadingQuerySearch.value &&
        CommonHelper.selectedSearchScopeOptions.value.length > 0 && CommonHelper.querySearchType.value.includes("advanced");
    });

    watch(runQueryAdvancedSearch, () => {
      if (runQueryAdvancedSearch.value) {
        emit("setSideBarMode", "advancedSearchHidden")
        searchScopes.value = [];

        Object.keys(CommonHelper.querySearchParameters.value).forEach((searchAttributeValue) => {
          var searchTextValue = CommonHelper.querySearchParameters.value[searchAttributeValue];

          if (searchAttributeValue === "location_id") {
            searchTextValue = LocSchoolMap[searchTextValue];
          }

          addGroupFunction(searchTextValue, searchAttributeValue);
        });

        submitAdvancedSearch();
      }
    });

    watch(metadataOptions, () => {
      // reset searchAttribute to "label" if selected value no longer exists in metadataOptions
      const metadataOptionValues = metadataOptions.value.map((metadataOption) => {
        return metadataOption.value;
      });

      searchScopes.value.filter((searchScope) => {
        return !metadataOptionValues.includes(searchScope.searchAttribute.value);
      }).forEach((searchScope) => {
        searchScope.searchAttribute = getSearchAttribute("label");
      });
    });

    return {
      //variable properties
      metadataOptions,
      searchScopes,

      //functions
      getSearchAttribute,
      addGroupFunction,
      deleteGroupFunction,
      setSearchText,
      submitAdvancedSearch,

      //helpers
      CommonHelper
    };
  },
};
</script>

<style type="text/scss" lang="scss">
.inputMetadataType {
  .q-field__control {
    border-radius: 10px 0px 0px 10px !important;
  }
}
.inputMetadataValue {
  margin-left: -12px !important;
  .q-field__control {
    border-radius: 0px 10px 10px 0px !important;
  }
}
</style>